import { Button, Col, Row } from "antd";
import React from "react";
import { useHardPromotionMutate } from "../contexts/hard-promotion.context";
import SelectOption from "../../../../../components/SelectOption";
import { STATUS_OPTIONS } from "../constants/status.constant";
import { useHistory } from "react-router-dom";
import { PROMOTION_TYPE_OPTIONS } from "../constants/type.constant";

const HardPromotionCriteria = () => {
  const history = useHistory();
  const {
    state: { filter },
    dispatch,
  } = useHardPromotionMutate();
  return (
    <Row className="mb-2">
      <Col className="d-flex justify-content-between">
        <div>
          <SelectOption
            value={filter.status}
            data={STATUS_OPTIONS}
            withAll
            allText="ทุกการแสดงผล"
            onChange={(value) =>
              dispatch({
                type: "SET_FILTER",
                payload: { status: value, page: 1 },
              })
            }
            style={{ minWidth: "200px" }}
          />
          <SelectOption
            value={filter.type}
            data={PROMOTION_TYPE_OPTIONS}
            withAll
            allText="ทุกประเภท"
            className="ml-2"
            onChange={(value) =>
              dispatch({
                type: "SET_FILTER",
                payload: { type: value, page: 1 },
              })
            }
            style={{ minWidth: "200px" }}
          />
        </div>
        <Button
          type="primary"
          ghost
          onClick={() => history.push(`/marketing/hard-promotion/new`)}
        >
          เพิ่มใหม่
        </Button>
      </Col>
    </Row>
  );
};

export default HardPromotionCriteria;
